import {createContext, useContext, useState} from "react";


const ContextAccountManagementSelectedAccount = createContext();

export default function Context_Provider_AccountManagement_SelectedAccount({children}){
    const [Accounts_Selected, Selected_Set] = useState(null);
    const [Change_InProgress, Change_InProgress_Set] = useState(false);

    return (
        <ContextAccountManagementSelectedAccount.Provider value={{ Accounts_Selected, Selected_Set, Change_InProgress, Change_InProgress_Set}}>
            {children}
        </ContextAccountManagementSelectedAccount.Provider>
    )
}

export function Accounts_Selected_Set(){
    return useContext(ContextAccountManagementSelectedAccount);
}